import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  filter,
  Subject,
  take,
} from 'rxjs';
import { search_filter } from '../../../_model/search_fliter';
import { AuthenticationService } from '../../_services/authentication.service';
import { ConstantService } from '../../_services/constant.service';
import { GlobalService } from '../../_services/global.service';
import { BusyService } from '../../_services/busy.service';
import { user_privilege } from '../../../_model/user_privilege';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CommanService } from '../../_services/comman.service';
import { tap, switchMap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-simple-search',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    DialogModule,
    ToastModule,
  ],
  providers: [MessageService],
  templateUrl: './simple-search.component.html',
  styleUrl: './simple-search.component.scss',
})
export class SimpleSearchComponent {
  simpleformvalue: any = {};
  isTableSimple: boolean = false;
  // @Output() receivesimplesearchdata = new EventEmitter<{
  //   response: string;
  //   userid: string;
  //   gbrn: string;
  //   INCHIKEY: string;
  //   currentFilterCondition: any;
  //   application_query: string;
  //   search_filters: search_filter;
  //   cols: any;
  //   columns: any;
  //   totalRecords: any;
  //   searchQueryGrid: string ;
  // }>();

  // @Output() emitUserPrivilege = new EventEmitter<{ privilege_json: any; userid: string; keyword?: string }>();

  TableName: string = 'basic_product_details_MONGO';
  pageTitile = 'QuikPatent';
  isSignedIn = false;
  tokenChecked = false;
  searchTypeOptions = [
    { type: 'Exact', label: 'Exact Search' },
    {
      type: 'Free',
      label: 'Free text search (Broad Search, it may take more time)',
    },
  ];
  searchOptions: any[] = [
    { name: 'Simple Search', value: 'SIMPLE' },
    { name: 'Advance Search', value: 'ADVANCE' },
    { name: 'Combination Search', value: 'COMBINATION' },
    // { name: "Claim / Example Search", value: "CLAIM" }
  ];
  gbrn: any;
  user_data: any;
  current_pagenumber!: number;
  filterForm_normal: FormGroup = new FormGroup({});
  selectedSearchOption = 0;
  searchForm!: FormGroup;
  items: any[] = [];
  selectedOption: string = '';
  formValues: any[] = [];
  results_suggestion: any[] = [];
  isShowQueryBox: boolean = false;
  isShowAutoSearch: boolean = false;
  isShowTable: boolean = false;
  isQueryErrorFound: boolean = false;
  noResultsFound: boolean = false; // Initialize it to false
  searchQueryGrid: string = '';
  searchType = 'Exact';
  patentTypes: any[] = [];
  addOnPatentTypes: any[] = [];
  filterForm_advanced: FormGroup = new FormGroup({});
  isShowAccessDialog: boolean = false;
  IsFilterAplied: boolean = false;
  analysisApi: boolean = false;
  isQueryOptionSelected: boolean = false;
  IsSuggestedItemClick: boolean = false;
  columns: any[] = [];
  isShowReadMoreDialog: boolean = false;
  initializedForm: boolean = false;
  isListView: boolean = true;
  isShowRaiseQuery: boolean = false;
  is_show_Total_Search_Exceed_popup: boolean = false;
  is_show_Search_Priv_popup: boolean = false;
  is_show_Daily_Search_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  productDetails: boolean = false;
  analysisView: boolean = false;
  isValidQueryCondition: boolean = true;
  currentFilterCondition: any = [];
  currentSortBy: string = 'gbrn ASC';
  application_query: string = '';
  search_filters!: search_filter;
  user_ip: string = '';
  address: string = '';
  additionalOperator: string = '';
  products_current_datasource: any[] = [];
  analysisFilterVal: any = [];
  rptDataForExcel: any = [];
  textsearch = '';
  searchedWords: string[] = [];
  searchFields = ['', 'combination'];
  SuggestedDbColumn: string = '';
  SuggestedDbField: string = '';
  dynSelectedPatentType: string = '';
  lastSearchQuery: string = '';
  readMoreColumn: string = '';
  readMoreContent: string = '';
  dateValue: any = {};
  tablefilter: any = {};
  analysisData: any = {};
  detailViewData: any = {};
  totalRecords: any;
  isLoadAutoSearch: boolean = false;
  updatePrivilege = false;
  loading_table = false;
  first = 0;
  oldResult: any = {};
  oldSearchQueryGrid = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  colCntAutoSearch: number = 0;
  privilege_json!: user_privilege;
  public searchTerms = new Subject<string>();
  postdata: any = {
    mode: 'GET_AUTO_SUGGEST',
  };
  results: string[] = [];
  searchCondition: any = {};
  columnMapping: any = {};
  isDataExistsAutoSearch: boolean = true;
  filteredProducts: any[] = [];
  dropdownSuggestions: any = [];
  operatorSelected: string = '';
  fieldSelected: string = '';
  matchText: string = '';
  searchValueFromEmail: string | null = null;
  rows!: number;
  cols: any[] = [];
  dropdownItems: any[] = [];
  selectedSearchType: any = 'activeIngredient';
  loadingCompleted: boolean = false;
  displayVideoModal: boolean = false;
  videoUrl: any;
  userId: string = '';
  regex_query =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  // search_regex_query = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>(?:[^(]+|\([^)]*\))*)\)/g;
  search_regex_query =
    /\s*(?<operator>AND|OR|NOT)?\s*(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\s*\((?<value>[^()]*?(?:\s+TO\s+[^()]*?)?)\)\s*/g;
  regex_query1 =
    /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+):(?<aditional_condition>EQUAL TO|NOT EQUAL TO|BETWEEN|NOT BETWEEN)?\((?<value>.*?)\)/gm;
  regex_query2 = /\s?(?<operator>AND|OR|NOT)?\s?(?<columnname>[\w\s]+)/gi;

  querySuggestions: any = [
    { search_value: 'AND', columnName: 'AND', label: 'Operator' },
    { search_value: 'OR', columnName: 'OR', label: 'Operator' },
    { search_value: 'NOT', columnName: 'NOT', label: 'Operator' },
    {
      search_value: 'EQUAL TO',
      columnName: 'EQUAL TO',
      label: 'Date Operator',
    },
    {
      search_value: 'NOT EQUAL TO',
      columnName: 'NOT EQUAL TO',
      label: 'Date Operator',
    },
    { search_value: 'BETWEEN', columnName: 'BETWEEN', label: 'Date Operator' },
    {
      search_value: 'NOT BETWEEN',
      columnName: 'NOT BETWEEN',
      label: 'Date Operator',
    },
    { search_value: '(term)', columnName: '(term)', label: 'Field Text' },
    {
      search_value: '(term1 AND term2)',
      columnName: '(term1 AND term2)',
      label: 'Field Text',
    },
    {
      search_value: '(term1 OR term2)',
      columnName: '(term1 OR term2)',
      label: 'Field Text',
    },
    {
      search_value: '(dd-mm-yyyy TO *)',
      columnName: '(dd-mm-yyyy TO *)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO * OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy AND dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
    {
      search_value: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      columnName: '(dd-mm-yyyy TO dd-mm-yyyy OR dd-mm-yyyy TO dd-mm-yyyy)',
      label: 'Field Date',
    },
  ];
  pageLimitInPrivilegeJson: any = 0;
  pageLimitInDatabaseLimit: any = 0;

  constructor(
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private globalService: GlobalService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private commanService: CommanService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.setIpandLocation();
    this.filterForm_normal = this.fb.group({
      search_type_simple: new FormControl('activeIngredient'),
      textautocomplete: new FormControl(''),
    });
    this.$searchKeyword
      .pipe(
        // If character length is greater than 2
        filter((res: any) => res.length > 2),
        // Time in milliseconds between key events
        debounceTime(1000),
        // If the previous query is different from the current
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        let searchvalue = text;

        // Define the search condition
        this.searchCondition = {};

        if (searchvalue != '') {
          let columnname = this.filterForm_normal.value.search_type_simple;

          // Split the search term into words using regex (accounting for special characters)
          let searchWordArr: any[] = [];
          if (typeof searchvalue === 'string') {
            searchWordArr = searchvalue?.split(/[\s,;]+/);
          } else if (typeof searchvalue === 'number') {
            searchWordArr = [searchvalue];
          } else {
            searchWordArr = [];
          }

          // Check if the column exists and add search condition
          if (!this.searchCondition.hasOwnProperty(columnname)) {
            this.searchCondition[columnname] = [];
          }

          // Add the regex for each word in the search term
          searchWordArr.forEach((text) => {
            this.searchCondition[columnname].push({
              [columnname]: { $regex: text, $options: 'i' },
            });
          });

          // Prepare the request object for fetching data
          this.postdata = {
            pagenumber: 1,
            rowscount: 10,
            searchCondition: this.searchCondition,
          };

          // Call the API with the prepared search condition
          this.datasearch.quik_patent_dropdown(this.postdata).subscribe(
            (res) => {
              let datasearch: any = [];
              let len =
                this.filterForm_normal.controls['textautocomplete'].value.trim()
                  .length;
              this.isShowAutoSearch = len > 2 ? true : false;
              if (len > 2) {
                let searchvalue =
                  this.filterForm_normal.controls[
                    'textautocomplete'
                  ].value.trim();
                this.searchTerms.next(searchvalue);
              } else {
                this.searchTerms.next('');
              }

              // Process the search results
              res.data.forEach((searchValue: any) => {
                // Split the search_value by semicolons
                let valArr = searchValue.search_value.split(/[;+]/);

                // Rejoin the split values into a full name
                valArr = valArr.map((val: string) => val.trim()).join('; '); // Join back with semicolons

                // Check if the value matches the search term
                if (
                  valArr
                    .toLowerCase()
                    .includes(
                      this.filterForm_normal.controls[
                        'textautocomplete'
                      ].value.toLowerCase()
                    )
                ) {
                  datasearch.push({
                    search_value: valArr,
                    columnname: searchValue.columnname,
                    label: searchValue.label,
                  });
                }
              });

              // Remove duplicate search values
              const unique = datasearch.filter((obj: any, index: any) => {
                return (
                  index ===
                  datasearch.findIndex(
                    (o: any) =>
                      obj.search_value === o.search_value &&
                      obj.columnname === o.columnname
                  )
                );
              });
              datasearch = unique;

              // Update the suggestion list
              this.results_suggestion = datasearch;
              this.colCntAutoSearch =
                this.results_suggestion.length > 0 ? 1 : 0;

              this.isDataExistsAutoSearch = this.results_suggestion.length > 0;
              this.isLoadAutoSearch = false;
            },
            (error) => {
              // Handle errors (if any)
              console.error('Error fetching data:', error);
            }
          );
        }
      });
  }

  ngOnInit() {
    this.commanService.getUserPrivilege().subscribe((priv: any) => {
      this.privilege_json = priv;
    });

    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      console.log('getLoginUser() emitted:', val);

      if (!val) {
        this.isSignedIn = false;
        this.user_data = null;
        return;
      }

      this.isSignedIn = true;

      const userid = val.userId || val.userid || val._id || val.id || null;

      console.log('Resolved userId:', userid);

      this.user_data = { userid };

      console.log('Normalized user_data:', this.user_data);

      this.loadSearchCols();
    });

    this.commanService.isTableSimple.subscribe((res) => {
      this.isTableSimple = res;
    });

    // This method get page limit data for XIM 1.0
    this.datasearch
      .GetDatabasePageLimit({
        database: 'discovery_suite',
      })
      .subscribe(
        (res: any) => {
          console.log('pageLimitInDatabaseLimit : ', res);
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
            console.log(
              'pageLimitInDatabaseLimit : ',
              this.pageLimitInDatabaseLimit
            );
          } else {
            console.log('Error success false');
          }
        },
        (error: any) => {
          console.log('Error :', error);
        }
      );

    // Get current page number and row
    combineLatest([
      this.commanService.currentPage,
      this.commanService.currentRow,
    ]).subscribe(([page, row]) => {
      if (this.current_pagenumber !== page || this.rows !== row) {
        this.current_pagenumber = page;
        // console.log("current page number : ",this.current_pagenumber);

        this.rows = row;

        this.handlePageLimit();

        if (this.pageLimitInPrivilegeJson) {
          if (this.current_pagenumber > Number(this.pageLimitInPrivilegeJson)) {
            // console.log("======+++++=======",Number(this.pageLimitInPrivilegeJson))
            this.commanService.userPageLimit.next(
              this.pageLimitInPrivilegeJson
            );
            this.commanService.showPageLimitWarning.next(true);
            setTimeout(() => {
              this.commanService.showPageLimitWarning.next(false);
            }, 1000);
            // this.messageService.add({
            //   severity: 'warn',
            //   summary: 'Page Limit Exceeded',
            //   detail: `You can only see ${this.pageLimitInPrivilegeJson} pages.`,
            //   life: 5000, // Duration in milliseconds
            // });
            // alert(
            //   'You can only see ' + this.pageLimitInPrivilegeJson + ' pages'
            // );
            return;
          }
        } else if (this.pageLimitInDatabaseLimit) {
          if (this.current_pagenumber > +this.pageLimitInDatabaseLimit) {
            this.commanService.userPageLimit.next(
              this.pageLimitInDatabaseLimit
            );
            this.commanService.showPageLimitWarning.next(true);
            setTimeout(() => {
              this.commanService.showPageLimitWarning.next(false);
            }, 1000);
            // this.messageService.add({
            //   severity: 'warn',
            //   summary: 'Page Limit Exceeded',
            //   detail: `You can only see ${this.pageLimitInPrivilegeJson} pages.`,
            //   life: 5000, // Duration in milliseconds
            // });
            // alert(
            //   'You can only see ' + this.pageLimitInDatabaseLimit + ' pages'
            // );
            return;
          } else {
            console.log('else execute');
          }
        }

        if (this.isTableSimple) {
          this.search();
        }
      }
    });

    // combineLatest([
    //   this.commanService.currentPage,
    //   this.commanService.currentRow
    // ]).subscribe(([currentPage, currentRow]: [any, any]) => {
    //   this.current_pagenumber = currentPage;
    //   this.rows = currentRow;
    //   this.search();
    // });

    this.globalService.sendMenuIndex(0);
    this.initializeForm();
    this.getdropdown();
    this.updatesimplesearch();

    // /////////////// Search By Email ///////////////
    this.globalService.getSearchByEmail_Data().subscribe((res) => {
      if (res) {
        if (res.searchType == 'Simple') {
          setTimeout(() => {
            this.filterForm_normal.setValue(res.searchValue);
            this.search();
            this.globalService.setSearchByEmail_Data(null);
          }, 2000);
        }
      }
    });
    this.commanService.resetFlag.subscribe((reset) => {
      if (reset) {
        this.resetForm();

        this.commanService.resetFlag.next(false); // Reset flag back to false after handling
      }
    });
  }

  // /////////////// Search By Email ///////////////
  // searchByEmail(res: any) {
  //   if (res.searchType == 'Simple') {
  //     console.log('??????????? ', res.searchValue);
  //     setTimeout(() => {
  //       console.log('-----------|||||||||||', this.filterForm_normal.value);
  //       this.filterForm_normal.setValue(res.searchValue);
  //       console.log('11111111111111', this.filterForm_normal.value);
  //     }, 2000);
  //     // this.search();
  //   }
  // }

  handlePageLimit() {
    this.pageLimitInPrivilegeJson =
      Number(this.privilege_json.PageLimit) || 0
        ? Number(this.privilege_json.PageLimit)
        : 0;

    // console.log(
    //   '-------------Privilege Json--------------- : ',
    //   this.privilege_json
    // );
    console.log(
      '-------------PageLimitInPrivilegeJson-------------- : ',
      this.pageLimitInPrivilegeJson
    );
    // console.log("-------------pageLimitInDatabaseLimit-------------- : ",this.pageLimitInDatabaseLimit);
  }

  truncateName(name: string, maxWords: number): string {
    const words = name.split(' ');
    return words.slice(0, maxWords).join(' ');
  }
  findActiveIngredientField(): string {
    const activeIngredientItem = this.dropdownItems.find((item: any) => {
      const f = (item.field || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const t = (item.tableColumnName || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const d = (item.displayColumnName || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const e = (item.excelColumnName || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const h = (item.header || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      return (
        f === 'activeingredient' ||
        t === 'activeingredient' ||
        d === 'activeingredient' ||
        e === 'activeingredient' ||
        h === 'activeingredient' ||
        f.includes('activeingredient') ||
        e.includes('activeingredient')
      );
    });

    if (activeIngredientItem) {
      return activeIngredientItem.field;
    }
    const hasField = this.dropdownItems.some((item: any) => item.field === 'activeIngredient');
    if (hasField) {
      return 'activeIngredient';
    }
    return this.dropdownItems[0]?.field || 'activeIngredient';
  }

  onDropdownChange(event: any) {
    const val = event?.value !== undefined ? event.value : event;
    if (val) {
      this.selectedSearchType = val;
      this.filterForm_normal.get('search_type_simple')?.setValue(val);
      this.saveSearchState();
    }
  }

  saveSearchState() {
    const searchFormVal = {
      search_type_simple:
        this.filterForm_normal.get('search_type_simple')?.value ||
        this.selectedSearchType ||
        this.findActiveIngredientField(),
      textautocomplete:
        this.filterForm_normal.get('textautocomplete')?.value || '',
    };
    this.commanService.simpleformvalue.next(searchFormVal);
    try {
      sessionStorage.setItem('simple_search_form_value', JSON.stringify(searchFormVal));
    } catch (e) {}
  }

  resetForm() {
    this.commanService.simpleformvalue.next({});
    try {
      sessionStorage.removeItem('simple_search_form_value');
    } catch (e) {}

    const defaultField = this.findActiveIngredientField();
    this.filterForm_normal.reset({
      search_type_simple: defaultField,
      textautocomplete: '',
    });
    this.selectedSearchType = defaultField;
  }
  resetallform() {
    this.commanService.resetFlag.next(true);
  }
  openSignInForm() {
    this.globalService.sendOpenSignInModal(true);
  }
  openSignUpForm() {
    this.globalService.sendOpenSignUpModal(true);
  }
  initializeForm() {
    // Normal Form
    this.filterForm_normal = this.fb.group({
      search_type_simple: [this.selectedSearchType || 'activeIngredient', Validators.required],
      textautocomplete: ['', Validators.required],
    });

    this.filterForm_normal.get('search_type_simple')?.valueChanges.subscribe((val) => {
      if (val && this.selectedSearchType !== val) {
        this.selectedSearchType = val;
      }
    });

    // Update the form with the object values
  }

  searchQuery() {
    // this.oldResult = {
    //   products_current_datasource: this.products_current_datasource,
    //   totalRecords: this.totalRecords,
    //   searchQueryGrid: this.oldSearchQueryGrid
    // }
    // this.showAnalysisView(true);
    this.analysisView = false;
    this.isQueryOptionSelected = true;
    // this.isQueryOptionSelected=false;
    this.isQueryErrorFound = false;
    //replace more than one space
    this.searchQueryGrid = this.searchQueryGrid.replace(/\s{2,}/gm, '');
    this.lastSearchQuery = JSON.stringify(this.searchQueryGrid);
    this.searchData();
  }
  search() {
    this.updatePrivilege = true;
    this.results_suggestion = [];
    this.isShowAutoSearch = false;

    if (this.checkUserSearchPrivillege() == false) {
      return;
    }

    if (!this.filterForm_normal.get('search_type_simple')?.value) {
      this.filterForm_normal.get('search_type_simple')?.setValue(this.selectedSearchType || this.findActiveIngredientField());
    }
    this.saveSearchState();

    this.formValues.push({
      selectedOption: this.selectedOption,
      inputText: this.filterForm_normal.value,
    });

    // Log the array to the console
    this.isShowTable = false;
    this.isQueryErrorFound = false;
    this.searchQueryGrid = '';
    this.searchData();
  }
  showVideoModal() {
    // URL of the video you want to display
    const videoLink =
      'https://www.chemrobotics.com/agropat/uploads/web_videos/ChemRobotics-AgroPat-Tutorial-Agrochemical-Pesticide.mp4';
    // Sanitize the URL and store it in videoUrl
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoLink);

    this.displayVideoModal = true; // Open the modal
  }
  checkUserSearchPrivillege(): boolean {
    this.IsFilterAplied = false;

    //Check User Have Access to Search
    if (!this.privilege_json.View) {
      console.log('User does not have view access');
      this.is_show_Search_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to view this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todaySearchCount =
      Number(this.privilege_json.today_search_count) || 0;
    const dailySearchLimit = Number(this.privilege_json.DailySearchLimit) || 0;
    console.log(
      `Checking daily search limit: today=${todaySearchCount}, limit=${dailySearchLimit}`
    );
    if (todaySearchCount >= dailySearchLimit) {
      console.log('Daily search limit exceeded');
      this.is_show_Daily_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily search limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const searchCount = Number(this.privilege_json.Search) || 0;
    console.log(`Checking total search count: remaining=${searchCount}`);
    if (searchCount <= 0) {
      console.log('Total search count exceeded');
      this.is_show_Total_Search_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available search limit.',
      });
      return false;
    }

    this.IsFilterAplied = true;
    this.privilege_json.Search = searchCount - 1;
    this.privilege_json.today_search_count = todaySearchCount + 1;

    // Save updated counts to localStorage
    const userid = this.user_data?.userid || 'guest';
    const dailyKey = `user_${userid}_daily_counts`;

    const today = new Date().toDateString();
    localStorage.setItem(
      dailyKey,
      JSON.stringify({
        date: today,
        today_search_count: this.privilege_json.today_search_count,
        today_download_count: this.privilege_json.today_download_count || 0,
      })
    );

    console.log(
      `Updated search counts: total=${this.privilege_json.Search}, today=${this.privilege_json.today_search_count}`
    );
    return true;
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', this.onOutsideClick.bind(this));
  }
  onOutsideClick(event: MouseEvent): void {
    const suggestionBox = document.querySelector(
      '.search_top_body_container_simple_mid_right_suggestion'
    );
    const targetElement = event.target as HTMLElement;

    // Check if the click is outside the suggestion box
    if (suggestionBox && !suggestionBox.contains(targetElement)) {
      this.isShowAutoSearch = false; // Hide suggestions
    }
  }

  //new
  // searchData(showDetailView?: boolean) {
  //   this.isShowQueryBox = false;

  //   // Check for Simple Search
  //   if (this.searchOptions[this.selectedSearchOption].value == 'SIMPLE') {
  //     if (!this.filterForm_normal.controls['textautocomplete'].value) {
  //       return; // If input is empty, don't search
  //     }
  //   }

  //   // Get filter conditions (for simple search)
  //   this.currentFilterCondition = this.getFilterCondition();
  //   // Ensure filter conditions are valid
  //   if (this.currentFilterCondition.length > 0) {
  //     this.currentFilterCondition.push({ isDeleted: { $ne: true } });
  //   }
  //   if (this.currentFilterCondition.length == 0) {
  //     return;
  //   }

  //   let postdata = {
  //     mode: 'GET_DATA',
  //     tablename: this.TableName,
  //     filterconditionQuikPatent: this.currentFilterCondition,
  //     pagenumber: this.current_pagenumber,
  //     rowscount: this.rows,
  //     sortby: this.currentSortBy,
  //     application_query: this.application_query,
  //     updatePrivilege: this.updatePrivilege,
  //     search_filters: this.search_filters,
  //     user_ip: this.user_ip ? this.user_ip : null,
  //     address: this.address ? this.address : null,
  //     userid: this.user_data.userid,
  //     columns: this.columns,
  //
  // : this.searchQueryGrid,
  //   };

  //   // Set loader active
  //   this.loading_table = true;

  //   // Prioritize `discovery_suite_data_count` response
  //   this.busyService.busy();
  //   this.datasearch
  //     .discovery_suite_data_count(postdata)
  //     .pipe(
  //       tap((res: any) => {
  //         // Process `discovery_suite_data_count` response
  //         let response = res;
  //         if (response?.status == 'error') {
  //           this.busyService.idle();
  //           this.loading_table = false;
  //           return;
  //         }

  //         this.totalRecords = response[0]?.TotalRecordsCount || 0;
  //         this.loadingCompleted = true;

  //         // Check if no records are found
  //         if (this.totalRecords === 0) {
  //           console.log('No results found');
  //           this.noResultsFound = true;
  //         } else {
  //           this.noResultsFound = false;
  //         }
  //       }),
  //       switchMap(() => {
  //         // After `discovery_suite_data_count`, proceed with `get_suite_data`
  //         return this.datasearch.get_suite_data(postdata);
  //       })
  //     )
  //     .subscribe(
  //       (res: any) => {
  //         this.busyService.idle();
  //         let response: any = res[0];

  //         if (response?.status == 'error') {
  //           this.loading_table = false;
  //           return;
  //         }

  //         // Process `get_suite_data` response
  //         const gbrnArray = response.map((item: any) => item.gbrn);
  //         const inchiKeyArray = response.map((item: any) => item.INCHIKEY);
  //         this.commanService.currentData.next({
  //           INCHIKEY: response[0]?.INCHIKEY,
  //           gbrn: response[0]?.gbrn,
  //           data: response,
  //           userid: this.user_data.userid,
  //           currentFilterCondition: this.currentFilterCondition,
  //           application_query: this.application_query,
  //           search_filters: this.search_filters,
  //           cols: res[1] || [],
  //           columns: this.columns,
  //           totalRecords: this.totalRecords,
  //           searchQueryGrid: this.searchQueryGrid,
  //           gbrnArray: gbrnArray,
  //           inchiKeyArray: inchiKeyArray,
  //         });

  //         this.commanService.isTableSimple.next(true);
  //         this.commanService.simpleformvalue.next(this.filterForm_normal.value);
  //         this.router.navigate(['/search']);
  //         this.loading_table = false;
  //       },
  //       (error) => {
  //         this.busyService.idle();
  //         this.loading_table = false;
  //       },
  //       () => {
  //         this.busyService.idle();
  //         this.loading_table = false;
  //       }
  //     );
  // }

  //old
  tableData: any = null;
  isDataApiDone: boolean = false;
  isCountApiDone: boolean = false;
  searchData(showDetailView?: boolean) {
    console.log('SearchData function called');
    console.log('Current privilege state:', {
      today_search_count: this.privilege_json.today_search_count,
      DailySearchLimit: this.privilege_json.DailySearchLimit,
      Search: this.privilege_json.Search,
    });
    this.IsFilterAplied = false;
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
    });
    this.isDataApiDone = false;
    this.isCountApiDone = false;

    this.isShowQueryBox = false;

    // Check for Simple Search
    if (this.searchOptions[this.selectedSearchOption].value == 'SIMPLE') {
      if (!this.filterForm_normal.controls['textautocomplete'].value) {
        return; //If input is empty then retun, don't search
      }
    }

    // Get filter conditions (for simple search)
    this.currentFilterCondition = this.getFilterCondition();
    const postdata = {
      search_type:
        this.searchOptions[this.selectedSearchOption]?.value || 'free',
      criteria: this.currentFilterCondition,
      pagenumber: this.current_pagenumber || 1,
      rowscount: this.rows || 10,
      sortby: this.currentSortBy,
      activityObj: {
        userId: this.user_data?.userid || 'guest',
        userEmail: this.user_data?.email || '',
        privilegeName: this.updatePrivilege || 'discovery_suite_access',
        mode: 'search',
        query: this.application_query || 'N/A',
        searchFilters: this.search_filters || 'N/A',
        userIp: this.user_ip || '',
        address: this.address || '',
      },
    };

    // Call the service to get data
    this.busyService.busy();
    try {
      this.datasearch.get_suite_data(postdata).subscribe(
        (res) => {
          this.busyService.idle();
          let response: any = res[0];
          this.tableData = res.data.results;
          this.totalRecords = res.data.totalCount || 0;
          console.log('table data : ', this.tableData);
          if (response?.status == 'error') {
            return;
          }

          // Emit search data
          // this.receivesimplesearchdata.emit({
          //     INCHIKEY: response[0]?.INCHIKEY,
          //     gbrn: response[0]?.gbrn,
          //     response: response,
          //     userid: this.user_data.userid,
          //     currentFilterCondition: this.currentFilterCondition,
          //     application_query: this.application_query,
          //     search_filters: this.search_filters,
          //     cols: res[1] || [], // Fallback to an empty array if undefined
          //     columns: this.columns,
          //     totalRecords: this.totalRecords, // Include totalRecords here
          //     searchQueryGrid: this.searchQueryGrid,
          // });
          // const gbrnArray = response.map((item: any) => item.gbrn);
          // const inchiKeyArray = response.map((item: any) => item.INCHIKEY);
          this.isDataApiDone = true;
          this.isCountApiDone = true;
          this.dataForTable(res);

          this.saveSearchState();
          this.commanService.isTableSimple.next(true);
          this.router.navigate(['/search']);
          this.loading_table = false;
        },

        (errorobj) => {
          this.busyService.idle();
        },
        () => {
          this.busyService.idle();
          this.loading_table = false;
        }
      );
    } catch (error) {
      this.busyService.idle();
    }

    // Get the count of total records
    // this.busyService.busy();
    // this.datasearch.discovery_suite_data_count(postdata).subscribe(
    //   (res) => {
    //     let response: any = res;

    //     if (response?.status == 'error') {
    //       this.busyService.idle();
    //       return;
    //     }
    //     this.busyService.idle();

    //     this.totalRecords = response[0]?.TotalRecordsCount || 0;

    //     this.loadingCompleted = true;

    //     this.isCountApiDone = true;
    //     this.dataForTable(this.tableData, this.totalRecords);

    // Check if no records are found
    // if (this.totalRecords === 0) {
    //   console.log('No results found'); // Log for debugging
    //   this.noResultsFound = true; // Set the flag to true
    // } else {
    //   this.noResultsFound = false; // Set the flag to false
    // }
    //   },
    //   (errorobj) => {
    //     this.busyService.idle();
    //   }
    // );
  }

  private existingValues: { [key: string]: boolean } = {};
  checkUserDownloadPrivillege(): boolean {
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    if (todayDownloadCount >= dailyDownloadLimit) {
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    if (downloadCount <= 0) {
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    return true;
  }

  loadSearchCols() {
    let postdata = {
      tablename: 'templateBasicProductDetailsMongos',
    };
    this.datasearch.GetTemplateCols(postdata).subscribe((res) => {
      this.columns = res.data;
      console.log('Columns for Search1111:', this.columns); // Debugging line
      this.columns.sort((a: any, b: any) => {
        return a.DisplayColumnName.localeCompare(b.DisplayColumnName);
      });
      this.columns.forEach((col) => {
        if (!this.existingValues[col.tableColumnName]) {
          this.querySuggestions.push({
            search_value: col.tableColumnName,
            columnName: col.DisplayColumnName,
            label: 'Field',
            fieldDataType: col.fieldDataType,
          });
          this.existingValues[col.tableColumnName] = true;
        }
      });
      if (!this.existingValues['patentType']) {
        this.querySuggestions.push({
          search_value: 'patentType',
          columnName: 'PATENT TYPE',
          label: 'Field',
        });
        this.existingValues['patentType'] = true;
      }
    });
  }

  // getUserPrivilege() {
  //   this.commanService.getUserPrivilege().subscribe((priv: any) => {
  //     this.privilege_json = priv;
  //   });
  //   // const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  //   // const userId = currentUser?.userid;

  //   // // ✅ Extract correct privilege object from API response
  //   // const privilege =
  //   //   currentUser?.user_privilege?.[`user_${userId}`]?.[
  //   //     'agropat-ultimate-discovery-suite-beta'
  //   //   ] || null;

  //   // if (privilege) {
  //   //   this.privilege_json = privilege;
  //   //   localStorage.setItem('userPrivilege', JSON.stringify(privilege));
  //   //   console.log('✅ Privilege set for Discovery:', this.privilege_json);
  //   // } else {
  //   //   console.warn('⚠ No Discovery privilege found for user.');
  //   // }
  // }

  staticSuggestion(columnname: any, title: any, search_value: any) {
    switch (columnname) {
      case 'keyword':
        this.IsSuggestedItemClick = false;
        this.SuggestedDbColumn = '';
        this.filterForm_normal.controls['textautocomplete'].setValue(
          search_value
        );
        this.saveSearchState();
        this.search();
        break;
      default:
        let searchItem = {
          columnname: columnname,
          field: title,
          search_value: search_value,
        };
        this.autoSearchSelect2(searchItem);
        break;
    }
  }

  autoSearchSelect(Item: any) {
    this.isShowAutoSearch = false;
    this.results_suggestion = [];
    this.filterForm_normal.get('textautocomplete')?.setValue(Item.search_value);
    this.saveSearchState();
    this.search();
  }
  autoSearchSelect2(Item: any) {
    this.isShowAutoSearch = false;
    this.results_suggestion = [];
    this.filterForm_normal.get('textautocomplete')?.setValue(Item.search_value);

    // Devendra Changes start (19-2-25)
    this.filterForm_normal.get('search_type_simple')?.setValue(Item.field);
    this.selectedSearchType = Item.field;

    // Devendra Changes end (19-2-25)
    this.saveSearchState();
    this.search();
  }
  $searchKeyword: Subject<string> = new Subject<string>();
  searchKeyword(event: any) {
    this.$searchKeyword.next(event.target.value);
  }
  getFilterCondition() {
    this.textsearch = '';
    this.analysisApi = false;
    let searchConditionArr: any[] = [];
    this.search_filters = new search_filter();

    this.searchedWords = [];

    if (!this.isQueryOptionSelected) {
      if (this.searchOptions[this.selectedSearchOption].value === 'SIMPLE') {
        this.searchType = this.filterForm_normal.value.search_type_simple || this.selectedSearchType || this.findActiveIngredientField();

        const upperKey = this.searchType
          ? this.searchType.toUpperCase().trim()
          : '';
        // console.log('🔍 Lookup key for mapping:', upperKey);

        let mappedColumnName = this.columnMapping[upperKey];

        // Auto-convert "ACTIVE INGREDIENT" → "activeIngredient"
        if (!mappedColumnName) {
          mappedColumnName = upperKey
            .toLowerCase()
            .replace(/ (\w)/g, (_, c) => c.toUpperCase())
            .replace(/\s+/g, '');
        }

        // console.log('✅ Final mapped column name:', mappedColumnName);

        let searchtext = '';

        if (this.filterForm_normal.controls['textautocomplete']) {
          searchtext =
            this.filterForm_normal.controls['textautocomplete'].value || '';
        }

        this.searchedWords.push(searchtext);
        searchtext = searchtext.replace(/\r?\n|\r/g, '').trim();
        const normalize = (str: string) =>
          str?.toLowerCase().replace(/[^a-z0-9]/g, '');

        const selectedColumn = this.columns.find((col: any) => {
          const tableCol = normalize(col?.tableColumnName);
          const mappedCol = normalize(mappedColumnName);
          return tableCol === mappedCol;
        });

        if (!selectedColumn) {
          console.warn('⚠️ No matching column found for:', this.searchType);
          return [];
        }

        let tableColumnName = selectedColumn.tableColumnName;
        let displayColumnName =
          selectedColumn.displayColumnName || selectedColumn.tableColumnName;

        console.log('✅ Selected column:', {
          tableColumnName,
          displayColumnName,
        });

        // If user didn't click a suggested item
        if (!this.IsSuggestedItemClick) {
          const splitSearchText = searchtext
            .split(';')
            .map((val: string) => val.trim());
          const searchWordArr = splitSearchText.filter((v) => v !== '');

          searchWordArr.forEach((text, index) => {
            searchConditionArr.push({
              field: tableColumnName,
              keyword: text,
              operator: index === 0 ? 'AND' : 'OR',
            });
          });

          this.searchQueryGrid = `${displayColumnName}: (${searchtext})`;
          console.log('searchQueryGrid :', this.searchQueryGrid);
        } else {
          // If suggested item selected
          if (searchtext.length > 0) {
            searchConditionArr.push({
              field: this.SuggestedDbField,
              keyword: searchtext.trim(),
              operator: 'AND',
            });
          }

          this.searchQueryGrid = `${this.SuggestedDbColumn}: (${searchtext})`;
        }

        this.search_filters.SeachType = 'Simple Filter';
        this.search_filters.textColumn = [this.searchType];
        this.search_filters.textValue = [searchtext];
      }
    }

    console.log(
      '🚀 [getFilterCondition] Final structured filters:',
      searchConditionArr
    );

    this.application_query = this.searchQueryGrid;

    return searchConditionArr;
  }

  getdropdown() {
    this.datasearch.getdropdown().subscribe(
      (res: any) => {
        // console.log('🚀 API Response:', res);

        // ✅ Extract the array safely from new response format
        const columnsArray = Array.isArray(res?.data?.results)
          ? res.data.results
          : [];

        if (!columnsArray.length) {
          console.error('🚫 Invalid dropdown response structure:', res);
          return;
        }

        // ✅ Save columns globally (if needed)
        this.commanService.currColumns$.next(columnsArray);
        this.items = columnsArray;

        // ✅ Filter items with viewInDropdown
        const visibleItems = this.items.filter(
          (item: any) =>
            item.viewInDropdown === true ||
            item.viewInDropdown === 1 ||
            item.viewInDropdown === 'true'
        );

        // ✅ Process data to truncate labels for dropdown display
        this.dropdownItems = visibleItems.map((item: any) => ({
          ...item,
          truncatedLabel: this.truncateName(
            item.displayColumnName ||
              item.header ||
              item.excelColumnName ||
              item.field,
            5
          ),
        }));

        // console.log('🎯 Dropdown Items:', this.dropdownItems);

        // ✅ Set activeIngredient as default selected dropdown value
        const defaultField = this.findActiveIngredientField() || 'activeIngredient';
        const savedField = this.simpleformvalue?.search_type_simple;
        const targetField =
          savedField && this.dropdownItems.some((item: any) => item.field === savedField)
            ? savedField
            : defaultField;

        this.selectedSearchType = targetField;
        this.filterForm_normal.get('search_type_simple')?.setValue(targetField);
        this.changeDetectorRef.detectChanges();
      },
      (error) => {
        console.error('❌ Error fetching dropdown data:', error);
      }
    );
  }

  setIpandLocation() {
    this.datasearch.getIpandLocation().subscribe({
      next: (res) => {
        this.user_ip = res.userip;
        this.address = res.address;
        console.log('🌐 User Info:', res);
      },
      error: (err) => {
        console.error('❌ Error fetching IP/Location:', err);
      },
    });
  }
  updatesimplesearch() {
    this.commanService.simpleformvalue.subscribe((res: any) => {
      let savedValue: any = res;

      // Fallback to sessionStorage if in-memory value has no keyword
      if (!savedValue || (!savedValue.textautocomplete && !savedValue.search_type_simple)) {
        try {
          const stored = sessionStorage.getItem('simple_search_form_value');
          if (stored) {
            savedValue = JSON.parse(stored);
          }
        } catch (e) {}
      }

      if (!savedValue || (typeof savedValue === 'object' && Object.keys(savedValue).length === 0)) {
        return;
      }

      this.simpleformvalue = savedValue;

      const patchObj: any = {};
      if (savedValue.search_type_simple) {
        patchObj.search_type_simple = savedValue.search_type_simple;
        this.selectedSearchType = savedValue.search_type_simple;
      }
      if (savedValue.textautocomplete !== undefined && savedValue.textautocomplete !== null && savedValue.textautocomplete !== '') {
        patchObj.textautocomplete = savedValue.textautocomplete;
      }

      if (Object.keys(patchObj).length > 0) {
        this.filterForm_normal.patchValue(patchObj);
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  dataForTable(apiResponse: any) {
    // Ensure API completed properly
    if (!apiResponse || !apiResponse.data || !apiResponse.data.results) {
      console.warn('⚠️ Invalid API response format:', apiResponse);
      return;
    }

    const data = apiResponse.data.results || [];
    const count = apiResponse.data.totalCount || 0;

    // Proceed only when both APIs done (if you’re still using those flags)
    if (this.isDataApiDone && this.isCountApiDone) {
      const gbrnArray = data.map((item: any) => item.gbrn).flat(); // handle arrays of gbrn
      const inchiKeyArray = data.map((item: any) => item.inchiKey || '');
      const activeIngredientArray = data.map(
        (item: any) => item.activeIngredient || ''
      );

      const payload = {
        inchiKey: data[0]?.inchiKey || '',
        gbrn: data[0]?.gbrn || [],
        activeIngredient: data[0]?.activeIngredient || '',
        data,
        userid: this.user_data?.userid || '',
        currentFilterCondition: this.currentFilterCondition,
        application_query: this.application_query,
        search_filters: this.search_filters,
        cols: this.columns || [],
        columns: this.columns,
        totalRecords: count,
        searchQueryGrid: this.searchQueryGrid,
        gbrnArray,
        inchiKeyArray,
        activeIngredientArray,
      };

      // ✅ Emit data to other components (table, analysis, etc.)
      this.commanService.currentData.next(payload);

      // ✅ Reset flags and state
      this.isDataApiDone = false;
      this.isCountApiDone = false;
      this.tableData = null;

      // ✅ Handle no results
      this.noResultsFound = count === 0;
    } else {
      return;
    }
  }

  downloadPDF() {
    const link = document.createElement('a');
    link.href = 'assets/pdf/AgroPat_Ultimate_Discovery_Suite_N.pdf';
    link.target = '_blank'; // Open in new tab
    // Removed: link.download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
